import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';
import { placeWorldShape, type ShapePlacement } from './worldShapeKit';

/** Sparse distant crowns at their authored proportions. The display height
 * matches this viewBox; no short hill tile is enlarged into a canopy curtain. */
function canopy(height: number, shapes: readonly ShapePlacement[]): ParallaxSvgSpec {
  const bank = `M0 ${height}V${height - 80}Q240 ${height - 96} 480 ${height - 82}`
    + `T960 ${height - 82}T1440 ${height - 82}T1920 ${height - 82}Q2160 ${height - 72} 2400 ${height - 80}V${height}Z`;
  return { tile: { viewBoxWidth: 2400, viewBoxHeight: height,
    path: [bank, ...shapes.map(shape => placeWorldShape(...shape))].join(' ') } };
}

export const FOREST_DEPTH_HEIGHTS = { deep_woods: 1152, old_grove: 1280 } as const;

export const FOREST_DEPTH_BACKDROPS = {
  deep_woods: canopy(1152, [
    ['oak', 100, 1152, 600, 940], ['willow', 1120, 1152, 530, 900],
    ['snag', 1990, 1152, 170, 1040],
  ]),
  old_grove: canopy(1280, [
    ['oak', 160, 1280, 680, 1160], ['oak', 1350, 1280, 600, 1020],
    ['snag', 2220, 1280, 120, 880],
  ]),
} satisfies Record<keyof typeof FOREST_DEPTH_HEIGHTS, ParallaxSvgSpec>;
